/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import React, { FC } from 'react';
import { Table } from 'react-bootstrap';

import { round } from 'utils';
import Loader from 'components/Loader';
import { useCustomerSalesHistory } from 'plugins/wbu/API/useCustomerSalesHistory';

import styles from '../index.module.scss';

type Props = {
  customerID: string | number;
  useOldSalesHistoryService: boolean;
};

const Sales: FC<Props> = ({ customerID, useOldSalesHistoryService }) => {
  const { loading, value: sales = [] } = useCustomerSalesHistory(customerID);
  const loadedWithNoDocuments = !loading && !sales.length;

  return (
    <Loader block withPadding loadingText="Fetching sales" show={loading}>
      {loadedWithNoDocuments && !useOldSalesHistoryService ? (
        <p style={{ color: 'gray' }}>
          This customer has no imported historical sales documents.
        </p>
      ) : (
        <Table responsive className={styles.salesHistory} size="sm">
          <thead>
            <tr>
              <th colSpan={2}>Date</th>
              <th colSpan={2}>Number</th>
            </tr>
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Qty</th>
              <th>Sum</th>
            </tr>
          </thead>

          <tbody>
            {sales.map(({ date_time, sales_document_number, rows }) => (
              <>
                <tr className={styles.header}>
                  <th colSpan={2}>{sales_document_number}</th>
                  <th colSpan={2}>{date_time}</th>
                </tr>
                {rows.map(
                  ({ code, product_name, amount, row_net_total }, index) => (
                    <tr key={String(index)}>
                      <td>{code}</td>
                      <td>{product_name}</td>
                      <td>{round(amount)}</td>
                      <td>{round(row_net_total)}</td>
                    </tr>
                  ),
                )}
              </>
            ))}
          </tbody>
        </Table>
      )}
    </Loader>
  );
};

export default Sales;
